import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useDataDogRum = () => {
  useEffect(() => {
    const datadogApplicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
    const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

    if (datadogApplicationId && datadogClientToken) {
      datadogRum.init({
        applicationId: datadogApplicationId,
        clientToken: datadogClientToken,
        site: 'datadoghq.com',
        service: 'air-frontend',
        env: process.env.NEXT_PUBLIC_VERCEL_ENV || 'development',
        version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 10,
        defaultPrivacyLevel: 'mask-user-input',
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        allowedTracingUrls: [
          // Match any subdomain of air.inc for production and staging environments
          /^https:\/\/.*?\.air\.inc/,
          // Match localhost for local development
          /^http:\/\/localhost/,
          'https://analytics-api.air.inc',
          process.env.NEXT_PUBLIC_API_ENDPOINT,
        ].filter(Boolean), // Remove any undefined/empty values
      });
    } else {
      console.warn(
        'Datadog RUM not initialized: Missing NEXT_PUBLIC_DATADOG_APPLICATION_ID or NEXT_PUBLIC_DATADOG_CLIENT_TOKEN environment variables',
      );
    }
  }, []);
};
